module.exports = __webpack_public_path__ + "img/app-screenshot-light-es.7189e638.png";